<template>
  <div class="inventory-sheets-chart">
    <apexchart
      type="bar"
      height="350"
      :options="chartOptions"
      :series="series"
    ></apexchart>
  </div>
</template>

<script>
import _ from 'lodash'

export default {
  name: 'InventorySheetsChart',
  props: {
    data: {
      type: Object,
      required: true,
    },
  },
  computed: {
    chartOptions() {
      return {
        chart: {
          type: 'bar',
          height: 350,
          stacked: false,
        },
        plotOptions: {
          bar: {
            horizontal: false,
            columnWidth: '55%',
          },
        },
        dataLabels: {
          enabled: false,
        },
        stroke: {
          show: true,
          width: 2,
          colors: ['transparent'],
        },
        xaxis: {
          categories: ['Roof', 'Siding', 'Vertical', 'Gable'],
        },
        yaxis: {
          title: {
            text: 'Linear Feet',
          },
        },
        colors: ['#f54526', '#5c11a2'],
        legend: {
          position: 'top',
        },
        tooltip: {
          y: {
            formatter: (val) => {
              return val.toFixed(2) + ' linear feet'
            },
          },
        },
      }
    },
    series() {
      const sheets = this.data?.sheets || {
        roof: { linearFeet: 0, count: 0 },
        siding: { linearFeet: 0, count: 0 },
        vertical: { linearFeet: 0, count: 0 },
        gable: { linearFeet: 0, count: 0 },
      }
      return [
        {
          name: 'Linear Feet',
          data: [
            sheets.roof.linearFeet,
            sheets.siding.linearFeet,
            sheets.vertical.linearFeet,
            sheets.gable.linearFeet,
          ],
        },
        {
          name: 'Sheet Count',
          data: [
            sheets.roof.count,
            sheets.siding.count,
            sheets.vertical.count,
            sheets.gable.count,
          ],
        },
      ]
    },
  },
}
</script>

<style lang="scss" scoped></style>



